var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropzone-podcast-template",
      attrs: { id: "dropzone-podcast-template" }
    },
    [
      _vm.uploadedPodcast.original_url
        ? _c("div", {
            staticClass: "fa fa-trash",
            attrs: { title: "Remove this source file" },
            on: {
              click: function($event) {
                return _vm.clearSource()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "m-b-10 small" }, [
        _c("div", [_vm._v("Supported formats: MP3,M4A,WMA")]),
        _vm._v(" "),
        _c("div", [_vm._v("Max file size = " + _vm._s(_vm.max_size) + "MB.")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.uploadedPodcast.original_url,
              expression: "!uploadedPodcast.original_url"
            }
          ],
          ref: "audioSourceSection",
          staticClass: "dropzone dropzone-area dz-podcast",
          class: { "dz-disabled": _vm.uploadedPodcast.isDropped },
          attrs: {
            id: _vm.elemId,
            title: "Drop files here or click to upload."
          }
        },
        [
          _c("div", { staticClass: "dz-message" }, [
            _c("div", { staticClass: "btn-browse btn-sm c-dz-progress" }, [
              _vm._v(_vm._s(_vm.status || "Upload"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description-txt sub-info" }, [
              _vm._v("Drop files here or click to upload.")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasError,
                    expression: "hasError"
                  }
                ],
                staticClass: "description-txt error show"
              },
              [
                _c("div", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_vm.errorMessage || "Something went wrong"))
                ]),
                _vm._v(" "),
                _c("i", [_vm._v("Max size: " + _vm._s(_vm.max_size) + "MB")])
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }